import React from 'react';
import { AutoAlert } from '../callCenterDashboardTypes';
import styles from './AutoAlertsCard.module.css';

interface AutoAlertsCardProps {
  alerts: AutoAlert[];
}

export const AutoAlertsCard: React.FC<AutoAlertsCardProps> = ({ alerts }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>⚡ System Auto-Generated Alerts</h3>
        <span className={styles.refresh}>Auto-refreshes every 1 min</span>
      </div>
      <div className={styles.grid}>
        {alerts.map((alert) => (
          <div key={alert.id} className={`${styles.alert} ${styles[alert.variant]}`}>
            <p className={styles.alertTitle}>{alert.title}</p>
            <p className={styles.alertDesc}>{alert.description}</p>
            <p className={styles.alertTime}>{alert.timeAgo}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
